/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BookAgentSpeechUsageMutationVariables = Types.Exact<{
  messageId: Types.Scalars['ID']['input'];
  token: Types.Scalars['String']['input'];
}>;


export type BookAgentSpeechUsageMutation = { bookAgentSpeechUsage: { __typename: 'AgentSpeechBookResult', booked: boolean, costUsd: number } };


export const BookAgentSpeechUsageDocument = gql`
    mutation BookAgentSpeechUsage($messageId: ID!, $token: String!) {
  bookAgentSpeechUsage(messageId: $messageId, token: $token) {
    booked
    costUsd
  }
}
    `;
export type BookAgentSpeechUsageMutationFn = Apollo.MutationFunction<BookAgentSpeechUsageMutation, BookAgentSpeechUsageMutationVariables>;

/**
 * __useBookAgentSpeechUsageMutation__
 *
 * To run a mutation, you first call `useBookAgentSpeechUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookAgentSpeechUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookAgentSpeechUsageMutation, { data, loading, error }] = useBookAgentSpeechUsageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBookAgentSpeechUsageMutation(baseOptions?: Apollo.MutationHookOptions<BookAgentSpeechUsageMutation, BookAgentSpeechUsageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookAgentSpeechUsageMutation, BookAgentSpeechUsageMutationVariables>(BookAgentSpeechUsageDocument, options);
      }
export type BookAgentSpeechUsageMutationHookResult = ReturnType<typeof useBookAgentSpeechUsageMutation>;
export type BookAgentSpeechUsageMutationResult = Apollo.MutationResult<BookAgentSpeechUsageMutation>;
export type BookAgentSpeechUsageMutationOptions = Apollo.BaseMutationOptions<BookAgentSpeechUsageMutation, BookAgentSpeechUsageMutationVariables>;